import classNames from 'classnames';
import { Icon, SvgAnimation } from '@/components/standalone';
import { useRef } from 'react';
import useOnScreen from '@/helpers/useOnScreen';
import styles from '@/styles/personae.module.scss';

function AuditorsMetricsSection() {
  const headingRef = useRef();
  const { isOnScreen: isHeadingOnScreen } = useOnScreen({
    ref: headingRef,
    threshold: 0.3,
    rootMargin: '0px',
    isOnce: true,
  });

  const animationRef = useRef();
  const { isOnScreen: isAnimationOnScreen } = useOnScreen({
    ref: animationRef,
    threshold: 0.5,
    rootMargin: '0px',
    isOnce: true,
  });

  return (
    <div className={classNames('section', styles.personaeSection)}>
      <div className={classNames('max-content-width', styles.classic)}>
        <div
          className={classNames(styles.personaeSectionText, {
            [styles.personaeSectionTextAppear]: isHeadingOnScreen,
          })}
          ref={headingRef}
        >
          <div className="tb-tag">
            <Icon name="ChartPie" />
            METRICS
          </div>
          <h2>Build your profile with metrics</h2>
          <p>
            Thanks to audits being linked to deployed smart contracts, we can
            calculate relevant and helpful metrics that will help you analyze
            and promote your work while proving your impact on the web3
            ecosystem.
          </p>
        </div>
        <div ref={animationRef} className={styles.personaeSectionAnimation}>
          <SvgAnimation
            name="Metrics"
            autoplay={isAnimationOnScreen}
            onComplete={(animation) => {
              animation.playSegments(
                [1.86 * 60, animation.getDuration() * 60],
                true,
              );
              // eslint-disable-next-line no-param-reassign
              animation.loop = true;
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default AuditorsMetricsSection;
